export const NextArrow = (props) => {
  const { onClick } = props;
  return (
    <div className="slider-arrow right-btn" onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="48"
        viewBox="0 0 48 48"
      >
        <path
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="m19 12l12 12l-12 12"
        />
      </svg>
    </div>
  );
};

export const PrevArrow  = (props) => {
  const { onClick } = props;
  return (
    <div className="slider-arrow left-btn" onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="48"
        viewBox="0 0 48 48"
      >
        <path
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M31 36L19 24l12-12"
        />
      </svg>
    </div>
  );
};